export const ChartCard = ({ title, subtitle, right, className = "", children, testId }) => (
  <div
    data-testid={testId}
    className={`flex flex-col overflow-hidden rounded-xl border border-border bg-card card-elevated transition-shadow duration-300 hover:shadow-lg ${className}`}
  >
    <div className="flex items-center justify-between border-b border-border/70 px-5 py-4">
      <div>
        <h3 className="text-sm font-semibold tracking-tight text-foreground">{title}</h3>
        {subtitle ? <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p> : null}
      </div>
      {right}
    </div>
    <div className="flex-1 p-5">{children}</div>
  </div>
);

export const SectionTitle = ({ title, description, eyebrow }) => (
  <div className="mb-7">
    <div className="mb-2 flex items-center gap-2">
      <span className="h-4 w-1 rounded-full bg-brand" />
      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">
        {eyebrow || "Brand Machine Group"}
      </span>
    </div>
    <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-[32px]">{title}</h1>
    {description ? <p className="mt-1.5 max-w-2xl text-sm text-muted-foreground">{description}</p> : null}
  </div>
);
